import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Tooltip from '../../../components/ui/Tooltip';

export const getCandidateLimitTooltip = (maxCandidates, isTopTierPlan = false, t) => {
  if (typeof t === 'function') {
    return t(
      isTopTierPlan ? 'candidates.limitReachedTop' : 'candidates.limitReachedUpgrade',
      { count: maxCandidates },
    );
  }
  return isTopTierPlan
    ? `You've reached your plan limit of ${maxCandidates} candidates. Remove a candidate to add more.`
    : `You've reached your plan limit of ${maxCandidates} candidates. Remove a candidate or upgrade your plan to add more.`;
};

const AddCandidateButton = ({
  onClick,
  isLimitReached = false,
  maxCandidates = 50,
  isTopTierPlan = false,
  className,
}) => {
  const { t } = useTranslation();

  const button = (
    <Button
      iconName="UserPlus"
      iconPosition="left"
      onClick={onClick}
      disabled={isLimitReached}
      className={className}
    >
      {t('candidates.addCandidate')}
    </Button>
  );

  if (isLimitReached) {
    return (
      <Tooltip
        content={getCandidateLimitTooltip(maxCandidates, isTopTierPlan, t)}
        align="end"
        placement="bottom"
        size="md"
        className={className}
      >
        <span className="inline-flex cursor-not-allowed shrink-0">
          {button}
        </span>
      </Tooltip>
    );
  }

  return button;
};

export default AddCandidateButton;
